var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1731988114443,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 5654,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 150,
    height: 150,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M883.2 560.8H140.8c-26.9 0-48.8-22-48.8-48.8 0-26.9 22-48.8 48.8-48.8h742.3c26.9 0 48.8 22 48.8 48.8 0.1 26.9-21.9 48.8-48.7 48.8z",
    "p-id": 5655
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M463.2 883.2V140.8c0-26.9 22-48.8 48.8-48.8 26.9 0 48.8 22 48.8 48.8v742.3c0 26.9-22 48.8-48.8 48.8-26.9 0.1-48.8-21.9-48.8-48.7z",
    "p-id": 5656
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.cc23b130245190bd2d4c08c3046d8c45.svg";
export { ForwardRef as ReactComponent };